import { CommerceConnectorApi } from '../types/api/commerce-connector-api';
import { BaseRouteProps } from '../types/route-props';
import { ATG_COMMERCE_CONNECTOR_PATH, SPRYKER_COMMERCE_CONNECTOR_PATH } from '../constants';
import { Method, callAxios, AxiosRequestConfig } from '../axios';
import { buildURL, isV3 } from '../common';
import { getBrandName } from '../locale';

export const getCommerceConnectorEndpointUrl = ({
  host = '',
  contextRoot,
  countryCode,
  languageCode,
}: BaseRouteProps): string => {
  if (isV3()) {
    return `${host}${SPRYKER_COMMERCE_CONNECTOR_PATH}`;
  }

  return buildURL({
    host,
    contextRoot,
    countryCode,
    languageCode,
    endpoint: ATG_COMMERCE_CONNECTOR_PATH,
  });
};

export const commerceConnectorApiFetchers = {
  getCommerceConnector: async ({
    host,
    contextRoot,
    countryCode,
    languageCode,
  }: BaseRouteProps) => {
    const GET_COMMERCE_CONNECTOR_URL = getCommerceConnectorEndpointUrl({
      host,
      contextRoot,
      countryCode,
      languageCode,
    });
    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: GET_COMMERCE_CONNECTOR_URL,
    };

    if (isV3()) {
      requestSettings.params = {
        'country-code': countryCode,
        'language-code': languageCode,
        brand: getBrandName(),
      };
    }

    const response = await callAxios<{
      response: CommerceConnectorApi.GetCommerceConnectorResponse;
    }>(requestSettings);
    return response.data;
  },
};
